import React from "react";

/**
 * Spinner
 */
export default () => {
  return (
    <div className="inb-loader" style={{ position: "absolute", left: "46%", top: "35%" }}>
      <div></div>
      <div></div>
    </div>
  );
};
